import React, { Component } from "react";
import { AccountUsersTable } from "./AccountUsersTable";

export class AccountUsers extends Component {
  render() {
    return <AccountUsersTable />;
  }
}
